import { cloneDeep } from 'lodash-es'
import * as Yup from 'yup'

export enum PAYMENT_FORM_FIELDS {
  AMOUNT = 'amount'
}

export interface PaymentForm {
  [PAYMENT_FORM_FIELDS.AMOUNT]: string;
}

export const PaymentFormLabels: Record<string, string> = {
  [PAYMENT_FORM_FIELDS.AMOUNT]: 'Amount'
}

export const defaultPaymentFormValues: PaymentForm = {
  [PAYMENT_FORM_FIELDS.AMOUNT]: ''
}

export const getInitialPaymentFormValuesResponse = (
  response: Partial<PaymentForm>
): PaymentForm => {
  return cloneDeep({
    [PAYMENT_FORM_FIELDS.AMOUNT]: response.amount || ''
  })
}
export const paymentValidationSchema = Yup.object({
  [PAYMENT_FORM_FIELDS.AMOUNT]: Yup.number()
    .typeError('Amount must be a number')
    .positive('Amount must be greater than 0')
    .required('Amount is required')
})
export const formatDateToISO = (date: Date) => {
  return `${date.toISOString().split('.')[0]}Z`
}
